module.exports = __webpack_public_path__ + "static/img/envelope03zh-tw.5f758b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hongbao/img/envelope03zh-tw.png
// module id = POIX
// module chunks = 1